import { render } from "./MenuHealthCompact.vue?vue&type=template&id=dafc413c&scoped=true"
import script from "./MenuHealthCompact.vue?vue&type=script&lang=js"
export * from "./MenuHealthCompact.vue?vue&type=script&lang=js"

import "./MenuHealthCompact.vue?vue&type=style&index=0&id=dafc413c&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dafc413c"]])

export default __exports__